<template>
  <div>
    <div
      v-if="$login.can('accounts.update')"
      class="mt-3 pb-4 add-user-wrapper form-group border-bottom"
    >
      <label>
        Add Users
      </label>

      <quick-selector
        ref="users"
        v-model="addUser"
        :options="searchedUsers"
        :selected="[]"
        :allow-creation="true"
        :async="true"
        class="mt-1"
        placeholder="Start typing to find an user..."
        @search-changed="delayGetUsers"
        @create="$router.replace({
          name: 'users.create',
          query: {
            onComplete: $route.path
          }
        })"
      >
        <span
          slot="option"
          slot-scope="prop"
        >
          {{ prop.option.name }} <span v-if="prop.option.email">
            ({{ prop.option.email }})
          </span>
        </span>
        <span
          slot="create-option"
          slot-scope="prop"
        >
          Create {{ prop.option.name }}
        </span>
      </quick-selector>
    </div>

    <div class="mb-3 mt-3 form-group">
      <label for="">
        Attached Users
      </label>
      <search
        v-model="params.search"
      />
    </div>

    <users-table :users="users">
      <template
        slot="options"
        slot-scope="scope"
      >
        <dropdown-option
          v-if="$login.can('users.update') && !scope.user.agreed_to_terms_of_use_at"
          class="page-header-dropdown-item"
          @click.native="deleteUser = scope.user"
        >
          <icon icon="cross-badge" />
          Detach user
        </dropdown-option>
      </template>
    </users-table>
    <pagination
      :data="pagination"
      :disabled="loading"
      @change-page="changePage"
    />

    <confirm
      v-if="deleteUser"
      :name="deleteUser.name"
      @confirmed="deleteSelectedUser"
    />
  </div>
</template>

<script>
import Confirm from '@/components/Confirm'
import {debounce} from '@/helpers'
import {search} from '@/helpers'
import UsersTable from '@/views/users/Table'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import QuickSelector from '@/components/QuickSelector'
import DropdownOption from '@/components/Dropdown/DropdownOption'
import {successNotification, errorNotification} from '@/notifications'

const defaultPagination = () => {
  return {
    page: 1,
    search: null,
  }
}

export default {
  components: {
    UsersTable,
    Search,
    Pagination,
    Confirm,
    QuickSelector,
    DropdownOption,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      loading: false,
      error: null,
      dates: null,
      addUser: [],
      deleteUser: null,
      searchedUsers: [],
      users: [],
      pagination: null,
      params: defaultPagination(),
    }
  },

  watch: {
    addUser () {
      if (this.addUser.length > 0) {
        const user = this.addUser[0]

        this.$http
            .post(`/accounts/${this.data.id}/users`, {
              user_id: user.id,
            })
            .then(this.addSuccessfully)
            .catch(this.addFail)
      }
    },

    deleteUser () {
      if (this.deleteUser) {
        this.$nextTick(() => this.$modal.show('confirm-delete'))
      }
    },

    'params': {
      deep: true,
      handler () {
        this.getUsers()
      },
    },

    'data.id': {
      deep: true,
      handler () {
        this.getUsers()
      },
    },
  },

  mounted () {
    this.getUsers()
  },

  methods: {
    getUsers () {
      const params = this.params

      this.$http
          .get(`/accounts/${this.data.id}/users`, {
            params,
          })
          .then((response) => {
            this.users = response.data.data
            this.pagination = response.data.meta
          })
    },

    deleteSelectedUser () {
      const params = {
        user_id: this.deleteUser.id,
      }

      this.$http
          .delete(
              `/accounts/${this.$route.params.accountId}/users`,
              {
                params,
              }
          )
          .then(this.deleteUserSuccessfully)
          .catch(this.deleteUserFail)
    },

    deleteUserSuccessfully () {
      const user = this.deleteUser

      this.users.splice(this.users.indexOf(user), 1)
      this.deleteUser = null
      this.$notify(successNotification(`Removed ${user.name} from ${this.data.name}`))
    },

    deleteUserFail (response) {
      const user = this.deleteUser

      this.addUser = []

      this.$notify(errorNotification(`Unable to remove ${user.name} from ${this.data.name}`))
    },

    gotUsers (response) {},

    addSuccessfully () {
      const user = this.addUser[0]

      this.users.unshift(user)

      this.addUser = []

      this.$notify(successNotification(`Added ${user.name} to ${this.data.name}`))
    },

    addFail (response) {
      const user = this.addUser[0]

      this.addUser = []

      this.$notify(errorNotification(`Unable to add ${user.name} to ${this.data.name}`))
    },

    setData (erer, subscription) {
      this.data = subscription.data
    },

    delayGetUsers: debounce(function (query) {
      search('users', query).then((response) => {
        this.searchedUsers = response.data
      })
    }, 200),

    changePage (page) {
      this.params.page = page
    },
  },
}
</script>
